export default "__VITE_ASSET__l6zN362W__"